<template>
  <section class="frank-modal">
    <modal-center
      ref="frankModal"
      name="frank-modal"
    >
      <template #content>
        <FrankChoice
          v-if="frankStore.product && frankStore.step === 1"
          @save="saveComparison"
        />
        <template v-else-if="frankStore.product && frankStore.step === 2">
          <FrankPositive v-if="frankStore.positive" />
          <FrankNegative v-else />
        </template>
        <FrankConfirmation v-if="frankStore.submitted && frankStore.step === 3" />
      </template>
    </modal-center>
  </section>
</template>
<script setup>
import { computed, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import ModalCenter from '../../../abstracts/elements/modal/center/modalCenter.vue';
import { useFrankStore } from './store/frankStore.js';
import FrankChoice from './FrankChoice.vue';
import FrankNegative from './FrankNegative.vue';
import FrankPositive from './FrankPositive.vue';
import FrankConfirmation from './FrankConfirmation.vue';

const frankStore = useFrankStore();
const frankModal = ref(null);
const { showFrank } = storeToRefs(frankStore);

watch(showFrank, (value) => {
    if (value) {
        frankModal.value.open();
    } else {
        frankModal.value.close();
    }
});

const emit = defineEmits(['save']);
const saveComparison = () => {
    emit('save');
};

</script>

<style lang="scss">
@use '_frankModal.scss';

</style>
